var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 2.33136V7.33136M19.1663 7.33136H14.1663M19.1663 7.33136L15.2997 3.69803C14.4041 2.80196 13.296 2.14737 12.079 1.79534C10.862 1.44331 9.5756 1.40532 8.33991 1.68491C7.10423 1.9645 5.95951 2.55256 5.01256 3.39421C4.06562 4.23586 3.34731 5.30368 2.92467 6.49803M0.833008 15.6647V10.6647M0.833008 10.6647H5.83301M0.833008 10.6647L4.69967 14.298C5.5953 15.1941 6.70332 15.8487 7.92035 16.2007C9.13738 16.5527 10.4238 16.5907 11.6594 16.3111C12.8951 16.0316 14.0398 15.4435 14.9868 14.6018C15.9337 13.7602 16.652 12.6924 17.0747 11.498",
    stroke: "#101828",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateTemplate);
export default __webpack_public_path__ + "static/media/update-template.557e8844be1f11db760ff3de9b888cb4.svg";
export { ForwardRef as ReactComponent };